/* eslint-disable react/prop-types */
import React from "react";
import useSettings from "@/hooks/useSettings";

const Template4 = ({ template, previewData }) => {
  const {
    settings: { restaurant = {} },
  } = useSettings();

  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || null;
  const restaurantName = restaurant?.outlet_name || restaurant?.legal_name;
  const restaurantAddress = restaurant?.address;
  const restaurantPhone = restaurant?.phone;
  const restaurantTin = restaurant?.vat_id;
  const restaurantWebsite = restaurant?.website;
  const templateTitle =
    previewData?.title || (isStrictPreview ? "N/A" : "Birthday Gift Card");
  const customerName =
    previewData?.customerName ||
    (isStrictPreview ? "Not provided" : "Md Rasel Mahmud");
  const cardCode = previewData?.code || (isStrictPreview ? "N/A" : "326562356");
  const quote = previewData?.message
    ? `\"${previewData.message}\"`
    : isStrictPreview
      ? "Not provided"
      : '"Happy Birthday Massage"';
  const paymentText = previewData?.paymentMethods?.length
    ? previewData.paymentMethods.map(m => m.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(", ")
    : isStrictPreview
      ? null
      : "Cash only";
  const orderTypeText = previewData?.orderTypes?.length
    ? `For ${previewData.orderTypes.map(t => t.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(" / ")} only`
    : isStrictPreview
      ? null
      : "for dine only";
  const isConjunction =
    previewData?.isConjunction !== null && previewData?.isConjunction !== undefined
      ? Boolean(previewData?.isConjunction)
      : previewData?.is_conjunction !== null && previewData?.is_conjunction !== undefined
        ? Boolean(previewData?.is_conjunction)
        : !isStrictPreview;
  const conjunctionText = isConjunction
    ? "Not conjunction with any other offer"
    : null;
  const expiryText =
    previewData?.expiryDate || (isStrictPreview ? null : "12/02/2026");
  const hasTerms =
    Boolean(previewData?.paymentMethods?.length) ||
    Boolean(previewData?.orderTypes?.length) ||
    Boolean(conjunctionText);

  return (
    <div className="flex items-center justify-center p-4 bg-gray-100 min-h-[400px]">
      <div
        data-export-capture="gift-card-template"
        className="w-full max-w-[380px] border border-gray-200 bg-white p-5 text-black shadow-md font-mono bg-cover bg-center"
        style={
          backgroundImage
            ? { backgroundImage: `url(${backgroundImage})` }
            : undefined
        }
      >
        <div className="bg-white/95">
          <div className="px-3 pt-2 text-center leading-tight">
            <h1 className="text-[18px] font-bold uppercase tracking-widest">
              {restaurantName || "NAGA INDIAN"}
            </h1>
            <p className="mt-1 text-[13px]">
              {restaurantAddress || "68 Brick Ln, London E1 6RL, United Kingdom"}
            </p>
            <p className="text-[13px]">
              Phone : {restaurantPhone || "011-23236767"}
            </p>
            <p className="text-[13px]">TIN No : {restaurantTin || "00000000"}</p>
            <p className="text-[13px]">
              website: {restaurantWebsite || "www.demo.com"}
            </p>
          </div>

          <div className="mt-3 border-t border-dashed border-black"></div>

          <div className="px-4 py-3 text-[15px] leading-relaxed">
            <div className="space-y-2">
              <p className="text-[16px] font-bold">{templateTitle}</p>
              <p className="font-semibold">{customerName}</p>
              <p>Code: {cardCode}</p>
              <p>{quote}</p>
            </div>

            {hasTerms ? (
              <div className="mt-6 space-y-2">
                <p className="text-[16px] font-bold">Terms & Conditions</p>
                <div className="h-1"></div>
                {paymentText ? <p>{paymentText}</p> : null}
                {orderTypeText ? (
                  <p>{orderTypeText}</p>
                ) : null}
                {conjunctionText ? (
                  <p>{conjunctionText}</p>
                ) : null}
                
              </div>
            ) : null}
            {expiryText ? <p>Exp.Date: {expiryText}</p> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template4;
